import type { ColumnSchema } from '@/components/crud/types';

import type { LiveCase } from '@/api/live-case';
import { hasConflicts } from '@/domain/live-case';

export const liveDetailColumns: ColumnSchema[] = [
  { type: 'text', prop: 'date', label: '投诉日', width: 108 },
  {
    type: 'text',
    prop: 'yc',
    label: '异常投诉',
    minWidth: 140,
    align: 'left',
    flex: true,
    showOverflowTooltip: true,
  },
  { type: 'text', prop: 'deptP', label: '生产部门', width: 96, align: 'center' },
  { type: 'text', prop: 'fzr', label: '负责人', width: 88 },
  { type: 'text', prop: 'planDate', label: '完成计划日', width: 112, align: 'center' },
  {
    type: 'text',
    prop: 'conflictStatus',
    label: '状态',
    width: 120,
    align: 'center',
    formatter: (_value, row) => (hasConflicts(row as LiveCase) ? '待确认' : '-'),
  },
];
